export const greyout = {
    backgroundColor:"#E5E4E2"
}